var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import moment from 'moment';
import { operationTypes } from "../../../constants/constants";
var messages = defineMessages({
    title: {
        id: 'member-area.operation_type_1',
        defaultMessage: 'Ставка'
    },
    ordinar: {
        id: 'bet_type.ordinar',
        defaultMessage: 'Одинар',
    },
    type_stake: {
        id: 'member-area.operation_type_1',
        defaultMessage: 'Ставка'
    },
    type_result: {
        id: 'member-area.operation_type_2',
        defaultMessage: 'Результат'
    }
});
var IsSingleHeader = /** @class */ (function (_super) {
    __extends(IsSingleHeader, _super);
    function IsSingleHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IsSingleHeader.prototype.render = function () {
        var _a = this.props, operationsData = _a.operationsData, operationType = _a.operationType;
        var stakeId = operationsData.StakeId;
        var SportClassName = operationsData.SportClassName;
        var ChampionshipName = operationsData.ChampionshipName;
        var Date = operationsData.Date;
        var EventName = operationsData.EventName;
        var FullDescription = operationsData.FullDescription;
        var typeCls = operationType === operationTypes.STAKE ? 'stake-history-type stake-history-type--stake' : 'stake-history-type stake-history-type--payment';
        var msg = operationType === operationTypes.STAKE ? _jsx(FormattedMessage, __assign({}, messages.type_stake)) : _jsx(FormattedMessage, __assign({}, messages.type_result));
        return [
            _jsxs("div", __assign({ className: 'header' }, { children: [_jsxs("div", __assign({ className: 'title' }, { children: [_jsx(FormattedMessage, __assign({}, messages.title)), " \u2116 ", stakeId] })), _jsxs("div", __assign({ className: 'sub' }, { children: [_jsxs("strong", { children: [SportClassName, " "] }), ChampionshipName, " ", moment(Date).format('DD.MM.YYYY HH:mm')] }))] }), '1'),
            _jsxs("div", __assign({ className: 'info' }, { children: [_jsx(FormattedMessage, __assign({}, messages.ordinar)), _jsx("span", __assign({ className: typeCls }, { children: msg }))] }), '2'),
            _jsx("div", __assign({ className: 'name' }, { children: EventName }), '3'),
            _jsx("div", __assign({ className: 'rate' }, { children: FullDescription }), '4')
        ];
    };
    IsSingleHeader.propTypes = {
        operationsData: PropTypes.object.isRequired
    };
    return IsSingleHeader;
}(React.Component));
export default IsSingleHeader;



// WEBPACK FOOTER //
// ./src/components/account-history/headers/IsSingleHeader.jsx